import { TextField } from "@mui/material";
import styled from "@emotion/styled";
import { useState } from "react";

const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
      color: '#fff',
    },
   
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'grey',
      },
      '&:hover fieldset': {
        borderColor: 'grey',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'grey',
        boxShadow:'0px 0px 3px #fff'
      },
    },
  });


// this component is use to accept number only;
const CustomInputDark = ({ label,color,sx,focused,placeHolder,name, value,type,onChange,optional,autoComplete,defaultValue,inputProps,compact,...props}) => {
  const showLabel = !compact && label;

  return (
    <CssTextField
      color={color}
      required={optional ? false : true}
      label={showLabel ? label : undefined}
      focused={focused}
      fullWidth={!compact}
      placeholder={compact ? (placeHolder || label || 'Search') : placeHolder}
      value={value}
      name={name}
      type={type}
      onChange={onChange}
      size={compact ? 'small' : 'medium'}
      className={compact ? 'header-search-field' : undefined}
      sx={{
        my: compact ? 0 : "5px",
        bgcolor: '#21232D',
        minWidth: compact ? 100 : undefined,
        width: compact ? '100%' : undefined,
        maxWidth: compact ? '100%' : undefined,
        '& .MuiOutlinedInput-root': compact ? { height: 34, bgcolor: '#21232D' } : undefined,
        '& .MuiOutlinedInput-input': compact ? { py: 0.75, px: 1, fontSize: 12 } : undefined,
        '& .MuiOutlinedInput-input::placeholder': compact ? {
          color: 'rgba(255,255,255,0.55)',
          opacity: 1,
        } : undefined,
        ...sx,
      }}
      InputProps={{ sx: { height: compact ? 34 : 50, fontSize: compact ? 12 : 10 }, endAdornment: props.endAdornment }}
      inputProps={{ style: { fontSize: compact ? 12 : 14, color: "#fff" }, ...inputProps }}
      InputLabelProps={showLabel ? { style: { fontSize: 14, color: '#fff' } } : undefined}
      autoComplete={autoComplete}
      defaultValue={defaultValue}
    />
  );
};

export default CustomInputDark;

